import React, { useEffect, useMemo, useRef } from 'react'
import { MozrestVenue } from '../models/MozrestVenue'
import TabPanel from '../buttons/TabPanel';
import { useTranslation } from 'react-i18next';

type Props = {
    venue: MozrestVenue;
}

const tabStrings = ["Listing", "ListingAnalytics", "ReviewsPage", "ReviewAnalytics", "ReplyTemplates", "Notifications"];
const MozrestListManager = ({ venue }: Props) => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = React.useState("Listing");
    const tabs = useMemo(() => {
        return tabStrings.map(tab => {
            return { label: t(`menu.listing_manager_tabs.${tab}`), value: tab }
        });
    }, [t("menu.listing_manager_tabs")]);
    const mozref = useRef<any>(null);

    useEffect(() => {
        // @ts-ignore
        mozref.current = mozrest.init('mozrest-root', {
            partnerId: process.env.REACT_APP_MOZREST_PARTNER_ID,
            accessKey: venue.accessKey,
            venueId: venue.venueId,
        });
    }, []);

    useEffect(() => {
        if (mozref.current) {
            mozref.current.showPage(selectedTab);
        }
    }, [selectedTab]);

    return (
        <div>
            <div className="bg-primary bg-opacity-90 py-4 px-4">
                <div className="font-bold text-white text-[24px]">
                    {t("navigation.mozrest")}
                </div>
            </div>
            <TabPanel
                selectedValue={selectedTab}
                setSelectedValue={(value) => setSelectedTab(value)}
                tabs={tabs}
            />
            <div className="px-4 pb-4">
                <div id="mozrest-root" style={{ width: "100%" }} >

                </div>
            </div>
        </div>
    )
}

export default MozrestListManager